<template>
  <div>
    <div class="tui-add">
      <el-button type="primary" @click="onClickAdd">新增</el-button>
    </div>
    <div class="tui-table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="Id" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="Name" label="名称" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="onClickDelete(scope.row.Id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="新增" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-input v-model="name" placeholder="请输入内容"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddUnitInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { GetUnitList, AddUnitInfo, DeleteUnitInfo } from "../../api/api";
export default {
  data() {
    return {
      dialogVisible: false,
      name: "",
      tableData: [],
    };
  },
  created() {
    this.GetUnitList();
  },
  methods: {
    async onClickDelete(Id) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteUnitInfo({
          Id: Id,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetUnitList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    async AddUnitInfo() {
      if (this.name == "") {
        this.$message({
          type: "error",
          message: "请输入内容",
        });
        return;
      }
      let res = await AddUnitInfo({
        name: this.name,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "成功",
        });
        this.GetUnitList();
        this.dialogVisible = false;
      }
    },
    onClickAdd() {
      this.name = "";
      this.dialogVisible = true;
    },
    async GetUnitList() {
      let res = await GetUnitList();
      if (res.data.success) {
        this.tableData = res.data.response;
      } else {
        this.tableData = [];
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tui-table {
  padding: 0 20px;
}
.tui-add {
  padding: 20px 20px 20px 0;
  display: flex;
  justify-content: flex-end;
}
</style>